import * as React from 'react';
import { css } from 'office-ui-fabric-react/lib/Utilities';
import { BaseText } from '../baseText/BaseTextField';
import * as CommonFieldStyles from '../Field.scss';
import './TextField.scss';

/**
 * @public
 */
export interface ITextFieldProps {
  /** Text to render */
  text: string | undefined;

  /** Text is safe to be used as inner HTML */
  isSafeToInnerHTML?: boolean;

  /** Apply special styling if an item is diabled */
  isDisabled?: boolean;

  /** aria label of the field. */
  ariaLabel?: string;

  /** Apply special styling if an item is truncated */
  isTruncated?: boolean;
}

/**
 * @public
 */
export const TextField: React.StatelessComponent<ITextFieldProps> = (props: ITextFieldProps) => {
  let { text, isSafeToInnerHTML, isDisabled, ariaLabel, isTruncated } = props;
  text = text || '';
  ariaLabel = ariaLabel || text;    // Default to text if no ariaLabel given

  if (!text) {
    return null; // save dom elements for empty column
  }

  if (isSafeToInnerHTML) {
    return (
      <div
        className={ css('od-FieldRenderer-text', {
          'is-truncated': isTruncated || false,
          [`${CommonFieldStyles.disabledField}`]: isDisabled || false
        }) }
        dangerouslySetInnerHTML={ { __html: text } }
      />
    );
  } else {
    return (
      <BaseText
        className='od-FieldRenderer-text'
        text={ text }
        isDisabled={ isDisabled }
        ariaLabel={ ariaLabel }
      />
    );
  }
};
